import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { fileUploadType } from 'src/types/banners';
import { eventManager, EventsListResponse } from 'src/types/events';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class EventsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getEventsList(params: {
    search: string;
    sort: string;
    filters: string;
    page: number;
    pageSize: number;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      EventsListResponse | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.events.eventsList,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getEventDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.events.eventDetails(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createUpdateEvent(
    event: eventManager
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.benefits.events.createUpdateEvent,
      body: event,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async uploadFile(
    file: fileUploadType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.files.upload,
      body: { ...file, optimizateImage: true },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async exportEvent(
    ids: string[],
    userName: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.benefits.events.exportData,
      body: { ids, userName },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
